<template>
      <base-modal
        :ref="modal.key"
        :show="open"
        :title="modalTitle"
        @on-confirm="sendFolder"
        @on-cancel="hide()"
        :okText="$t('Save')"
        :closeText="$t('Close')"
    >
    <v-treeview
        v-model="folderSelected"
        :items="treeItems"
        :load-children="fetchChildren"
        item-key="id"
        item-text="text"
        item-children="children"
        return-object
        open-on-click
        activatable
        dense
        hoverable
        selectable
        :selection-type="'independent'"
        @input="restrictToSingleSelection"
    />
    </base-modal>
</template>
<script>
import CloudDriveService from '../../../../services/CloudDriveService';

export default {
    name: 'TreeViewFoldersModal',
    props: {
        treeItems: {
            type: Array
        },
        token: {
            type: Object
        },
    },
    data() {
        return {
            modal: {
                title: this.$t('RootFolder'),
                key: 'treeViewFoldersModal',
            },
            open: false,
            folderSelected: [],
            itemId: null,
            serviceId: null
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return this.modal.title;
        }
    },
    methods: {
        sendFolder() {
            this.$emit('on-folder-selected', this.folderSelected[0]);
            this.hide();
        },
        async fetchChildren(item) {
            this.modalInstance.progress(true);

            let response = [];
            const foldersRequest = {
                RefreshToken: this.token.RefreshToken,
                ParentFolderId: item.id,
                DocECMContentTypeAutoImportConfigService: this.serviceId,
            };
            response = await CloudDriveService.getFolders(foldersRequest);
            item.children = response.folders.map(r => ({
                id: r.id,
                text: r.text,
                ...(r.hasChildren ? { children: [] } : {})
            }));
            this.modalInstance.progress(false);
            return response;
        },
        restrictToSingleSelection(selectedIds) {
            if (selectedIds.length > 1) {
                const lastSelected = selectedIds[selectedIds.length - 1];
                this.folderSelected = [lastSelected];
            }
        },
        new() {
            this.show();
        },
        show(itemId, serviceID) {
            this.itemId = itemId;
            this.serviceId = serviceID;
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>